import {
  Receipt21,
} from "iconsax-react";
const data = [
   {
    id: "blog",
    icon: <Receipt21 size={20} />,
    label: "Blog",
  },
];
export default data;
